import * as actionTypes from '../actions/types';

const initialState = {
  trigger: {},
  guide: {},
  keyVar: {},
  crisis: {},
};

const milestoneColors = {
  trigger: '#aea8d4',
  guide: '#8fcbe3',
  keyVar: '#94c9b7',
  crisis: '#fdeab0',
  triumph: '#f092a4',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_MILESTONE_CONNECTOR:
      return {
        ...state,
        [action.connectorName]: {
          ...state[action.connectorName],
          [action.id]: {
            id: action.id,
            title: action.title,
            content: action.content,
            connectorName: action.connectorName,
            color: milestoneColors[action.connectorName],
            productIds: [],
            products: [],
            personaIds: [],
            personas: [],
          },
        },
      };

    case actionTypes.DELETE_MILESTONE_CONNECTOR:
      // object destructuring to remove the connector we want to delete
      // updatedConnectors are all the connectors that we want to keep
      const { [action.id]: deleteConnector, ...updatedConnectors } = state[
        action.connectorName
      ];

      return {
        ...state,
        [action.connectorName]: { ...updatedConnectors },
      };

    case actionTypes.UPDATE_CONNECTOR_PRODUCT:
      return {
        ...state,
        [action.connectorName]: {
          ...state[action.connectorName],
          [action.id]: {
            ...state[action.connectorName][action.id],
            productIds: [...action.products],
          },
        },
      };

    case actionTypes.UPDATE_CONNECTOR_PERSONA:
      return {
        ...state,
        [action.connectorName]: {
          ...state[action.connectorName],
          [action.id]: {
            ...state[action.connectorName][action.id],
            personaIds: [...action.personas],
          },
        },
      };

    case actionTypes.UPDATE_CONNECTOR_CONTENT:
      return {
        ...state,
        [action.connectorName]: {
          ...state[action.connectorName],
          [action.id]: {
            ...state[action.connectorName][action.id],
            title: action.title,
            content: action.content,
          },
        },
      };

    default:
      return state;
  }
};
